import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DButton from "discourse/components/d-button";
import { i18n } from "discourse-i18n";

export default class CircleDeleteButton extends Component {
  @service dialog;
  @service router;

  @tracked destroying = false;

  get canDelete() {
    return !!(this.args.model?.category_id && this.args.model?.can_delete);
  }

  @action
  destroyCircle() {
    this.destroying = true;

    const model = this.args.model;
    let message = i18n("discourse_circles.circle.confirm_delete.question", {
      name: model.name,
    });

    if (model.has_messages && model.message_count > 0) {
      message = i18n(
        "discourse_circles.circle.confirm_delete.question_with_messages",
        {
          count: model.message_count,
        }
      );
    }

    return this.dialog.confirm({
      title: i18n("discourse_circles.circle.confirm_delete.title", {
        name: model.name,
      }),
      message,
      confirmButtonLabel: "discourse_circles.circle.confirm_delete.confirm",
      cancelButtonLabel: "cancel",
      didConfirm: () => {
        let deleted = false;

        model
          .destroy()
          .then(() => (deleted = true))
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            this.dialog.alert(i18n("discourse_circles.circle.errors.delete"));
          })
          .then(() => {
            // the route transition must be chained after the catch because
            // Ember can abort the original transition to redirect the page
            // using query params. in this case we can ignore the error
            // TransitionAborted
            if (deleted) {
              this.args.onAfterDelete?.() ||
                this.router.transitionTo("circles.index");
            }
          })
          .finally(() => (this.destroying = false));
      },
      didCancel: () => (this.destroying = false),
    });
  }

  <template>
    {{#if this.canDelete}}
      <DButton
        @action={{this.destroyCircle}}
        class="circles-delete-button btn-danger"
        @disabled={{this.destroying}}
        @icon="trash-can"
        @label="discourse_circles.circle.actions.delete"
      />
    {{/if}}
  </template>
}
